/**
 * Given an array of table row data, a field to sort by, a field value, and
 * a direction, returns a new array with the data sorted.
 *
 * @param {array} rows - The array of row data to be sorted.
 * @param {string|number} field - The field to sort by.
 * @param {string} direction - Either 'ASC' or 'DESC'.
 */
export default function sortRowsByField(rows, field, direction) {
  const sortMultiplier = 'ASC' === direction ? 1 : - 1;

  // Make a deep copy of the rows array to avoid side effects.
  const newRows = rows.map((row) => ({ ...row }));

  switch (field) {
    case 'companyName':
      newRows.sort((itemA, itemB) => itemA.company.name.localeCompare(
        itemB.company.name) * sortMultiplier);
      break;
    case 'memberName':
      newRows.sort((itemA, itemB) => {
        // First, sort by last name.
        const lastName = itemA.member.lastName.localeCompare(
          itemB.member.lastName) * sortMultiplier;
        if (0 !== lastName) {
          return lastName;
        }

        // Next, sort by first name.
        return itemA.member.firstName.localeCompare(
          itemB.member.firstName) * sortMultiplier;
      });
      break;
    default:
      newRows.sort((itemA, itemB) => {
        const valueA = itemA[field] || 0;
        const valueB = itemB[field] || 0;
        return (valueA - valueB) * sortMultiplier;
      });
      break;
  }

  return newRows;
}
